<template>
  <pl-dialog
    :title="'Heads up!'"
    :size="'sm'"
    :disableOutsideClick="true"
    @close="$emit('close')"
  >
    <div class="ph3" style="text-align: justify">
      <p>
        Your co-teachers in this Parlay Course might not be co-teachers in the
        <span class="b">{{ integration.provider_name }} </span> course that you
        have connected <span class="b"> ({{ integration.course_name }}) </span>.
      </p>
      <p class="b" v-for="teacher in integration.teachers" :key="teacher">
        {{ teacher }}
      </p>
      <p>
        They will still be able to perform everything in Parlay, but they won't
        be able to sync assignments or assessment data with your
        {{ integration.provider_name }} class.
      </p>
      <p>
        If you want them to able to this, add them as a co-teacher inside your
        {{ integration.provider_name }} class as well.
      </p>
    </div>
    <div class="pv2">
      <pl-button
        class="pl-primary"
        style="font-size: 16px"
        @click.native="$emit('close')"
      >
        Okay, Got it.
      </pl-button>
    </div>
  </pl-dialog>
</template>

<script>
  export default {
    data() {
      return {};
    },
    props: {
      integration: {
        type: Object,
        default: {},
      },
    },
  };
</script>

<style></style>



// WEBPACK FOOTER //
// integrationTeacherNotInCourseModal.vue?22e5bba0